import React from 'react'

import { GroupButtonProps } from 'api/model/dataset/datasetGroups';
import { Button } from 'primereact/button';
import { useDeleteDatasetGroup } from 'api/api-hooks/dataset-groups-hooks';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';

const DeleteGroupButton: React.FC<GroupButtonProps> = ({ group }) => {
  const { mutateAsync } = useDeleteDatasetGroup();

  const confirmDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    confirmPopup({
      target: e.currentTarget,
      message: 'Are you sure you want to delete this group?',
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-danger',
      accept: async () => {
        await mutateAsync(group!);
      }
    })
  }
  return (
    <>
    <ConfirmPopup />
    <Button label="Delete group" icon="pi pi-trash" className="p-button-danger" disabled={!group} onClick={confirmDelete}/>
    </>
  );
}

export default DeleteGroupButton